<template>
  <div class="search-map-container" :style="mapElStyles">
    <slot />
  </div>
</template>

<script>
import jobSearchGlobal from "../../../globalSettingProps/jobSearchDefaultGlobalProp.js";

export default {
  name: "SearchMapContainer",
  provide() {
    return {
      jobSearchGlobal: this.jobSearchGlobal,
      tilesUrl: this.tilesUrl,
      cdnUrl: this.cdnUrl,
      mapLanguage: this.mapLanguage,
    };
  },
  props: {
    jobSearchGlobal: {
      type: Object,
      default() {
        return jobSearchGlobal;
      },
    },
    mapLanguage: {
      type: String,
      default: "en",
    },
    tilesUrl: {
      type: String,
      default: "https://tiles.api.jobshop.dev/region.json",
    },
    cdnUrl: {
      type: String,
      default: "https://cdn.dev05.jobshop.dev",
    },
  },
  computed: {
    mapElStyles() {
      if (this.jobSearchGlobal) {
        const { markerColor } = this.jobSearchGlobal.config.map;

        return {
          "--search-filter-map-marker-color": markerColor.value,
        };
      }
    },
  },
};
</script>
